<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202505_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202505_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>スキンケアに正解はないけど</span><br>オールインワンと通常ステップ。あなたに合うのはどっち？</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">忙しい毎日、スキンケアは「手軽さ」か「丁寧さ」か</h3>
        <p class="mb-3">朝はバタバタ、夜はクタクタ……そんな毎日のなかで、「できるだけ簡単にスキンケアを済ませたい」と思うことはありませんか？</p>
        <p class="mb-3">オールインワンタイプのスキンケアは、そんな忙しい方の味方として人気を集めています。</p>
        <p class="mb-3">一方で、化粧水からクリームまで段階的に重ねる“基本ステップ”を大切にしている方も多くいらっしゃいます。丁寧に肌と向き合うその時間が、自分と向き合うリラックスタイムになっているのかもしれません。</p>
        <p>どちらにも良さがあり、大切なのは“自分に合った方法”を見つけることです。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202505_02.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202505_03.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">オールインワンってどういうもの？</h3>
        <p class="mb-3">オールインワンとは、化粧水・美容液・乳液・クリームなどの役割がひとつにまとまったスキンケアアイテムのことです。</p>
        <p class="mb-3">1本でケアが完了するので、忙しい朝や疲れた夜にも手軽にお手入れできるのが魅力です。</p>
        <p class="mb-3">最近は、保湿やハリ対策などに対応した高機能タイプも増えています。</p>
        <p>ただし、肌の調子に合わせて細かくお手入れ内容を変えるのが難しかったり、年齢肌や乾燥などへの集中ケアにはやや物足りなさを感じることもあるかもしれません。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">ステップスキンケアが選ばれ続ける理由</h3>
        <p class="mb-3">化粧水、美容液、乳液、クリームと、順番に重ねていくステップケア。</p>
        <p class="mb-3">それぞれの役割をきちんと分けて、段階的に肌を整えていくことで、より深く・じっくりとお手入れができます。</p>
        <p class="mb-3">肌のコンディションや季節に合わせて、「今日はこっちの化粧水にしよう」「クリームをしっかり塗ろう」と、日々調整できるのもメリットのひとつです。</p>
        <p>少し手間はかかりますが、自分の肌と向き合う時間として、心まで整うような“ケアの時間”になる方も多いのではないでしょうか。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202505_04.jpg">
      </div>
    </div>

    <h2 class="my-5 pt-5">どちらが合う？オールインワンとステップケアのちがい</h2>
    <img src="@/assets/img/column/202505_05.jpg" class="only_pc">
    <img src="@/assets/img/column/202505_05_sp.jpg" class="only_sp">
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">“使い分ける”という選択肢も</h3>
        <p class="mb-3">「朝はオールインワンで時短、夜はステップケアでじっくり」</p>
        <p class="mb-3">「春夏はさっぱり1本、秋冬は重ねてしっかり」など、状況によってスキンケアを“使い分ける”のもおすすめです。</p>
        <p class="mb-3">肌は、体調や季節、年齢によって変化します。</p>
        <p>だからこそ、自分の生活スタイルや肌のリズムにあったケアを選ぶことが、未来の美肌づくりにつながっていきます。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202505_06.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202505_07.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">“自然派”を選ぶことが、肌へのやさしさにつながる</h3>
        <p class="mb-3">毎日使うスキンケアだからこそ、できるだけやさしいものを選びたい。そう思う方は多いはず。</p>
        <p class="mb-3">植物由来の自然派アイテムは、肌に必要なものだけを厳選して、不要なものをできるだけ取りのぞくという考え方で作られています。</p>
        <p class="mb-3">マナビス化粧品も、自然由来の成分を活かしながら、敏感な肌にも使いやすいやさしさを大切にしています。</p>
        <p>使った瞬間から肌になじむようなテクスチャーと、ふっと気持ちがゆるむような使用感は、心にも穏やかな余白をくれる存在です。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">“医薬部外品”というもうひとつの安心感</h3>
        <p class="mb-3">マナビス化粧品のスキンケアアイテムには「医薬部外品」のアイテムが多くあります。</p>
        <p class="mb-3">「医薬部外品」とは、厚生労働省が認めた効果・効能に有効な成分が、一定の濃度で配合されている製品のこと。</p>
        <p class="mb-3">肌あれや乾燥を防ぐ成分、美白※有効成分などが配合されていて、やさしいだけでなく「ちゃんと効いてくれる」ことも魅力です。</p>
        <p class="mb-3">「肌にやさしいのに、きちんと実感できる」そんな理想を叶えてくれるのが、マナビスの強みです。</p>
        <p>※美白：メラニンの生成を抑え、しみ・そばかすを防ぐこと</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202505_08.jpg">
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3 fs-2">自分の肌と向き合うって、ちょっと心地いい</p>
        <p class="mb-3">毎日のスキンケアは、肌を整えるだけじゃなく、自分と向き合う時間でもあります。</p>
        <p class="mb-3">手間をかけたくない日も、ゆっくり向き合いたい夜も。</p>
        <p class="mb-3">どんなときも、あなたの肌に寄り添える存在がそばにあることは、大きな安心になります。</p>
        <p class="mb-3">マナビス化粧品は、やさしさと確かな効果を両立したステップスキンケアで、毎日の肌をすこやかに整え、未来の美しさへと導きます。</p>
        <p>「どんな自分にもやさしくなれる」そんなスキンケアを、あなたの肌で実感してみてください。</p>
      </div>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  /* padding: 10px; */
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide img {
  width: 100%;
  height: 422px;
  object-fit: cover;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
    .img-top-slide_text {
      left: 10px;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
   .img-top-slide img {
    height: 650px;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>